import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { SITE, WA_PROYECTO } from '../site'
import Icon from './icon'
import './layout.css'

const NAV = [
  { to: '/#productos', label: 'Productos' },
  { to: '/#servicios', label: 'Servicios' },
  { to: '/#nosotros', label: 'Nosotros' },
  { to: '/#contacto', label: 'Contacto' },
]

// Al cambiar de ruta sube al inicio, o baja a la sección si la URL trae #ancla.
// Un enlace con state { keepScroll: true } (las pestañas del centro de ayuda) deja el scroll como está.
export const useScrollOnNavigate = () => {
  const { pathname, hash, state } = useLocation()
  const keepScroll = Boolean(state && state.keepScroll)
  useEffect(() => {
    if (keepScroll) return
    if (!hash) {
      window.scrollTo(0, 0)
      return
    }
    const el = document.getElementById(hash.slice(1))
    if (el) el.scrollIntoView()
  }, [pathname, hash, keepScroll])
}

export const Logo = () => (
  <Link to="/" className="logo" aria-label="Variant, inicio">
    <img src="/logo-variant.png" alt="" width="32" height="32" />
    <span>Variant</span>
  </Link>
)

const Header = () => {
  const [open, setOpen] = useState(false)
  const { pathname, hash } = useLocation()

  useEffect(() => setOpen(false), [pathname, hash])

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <Logo />
        <nav className={`site-nav${open ? ' is-open' : ''}`} aria-label="Principal">
          {NAV.map((item) => (
            <Link key={item.to} to={item.to} className="site-nav__link">
              {item.label}
            </Link>
          ))}
          <a href={WA_PROYECTO} className="btn btn--primary btn--sm" target="_blank" rel="noopener noreferrer">
            Hablemos
          </a>
        </nav>
        <button
          type="button"
          className="menu-toggle"
          aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <Icon name={open ? 'close' : 'menu'} size={22} />
        </button>
      </div>
    </header>
  )
}

const Footer = () => (
  <footer className="site-footer">
    <div className="container">
      <div className="site-footer__grid">
        <div className="site-footer__brand">
          <Logo />
          <p>Agentes de inteligencia artificial que automatizan el trabajo repetitivo de personas y empresas.</p>
          <p className="site-footer__legal">
            {SITE.legalName}
            {SITE.nit && <><br />NIT {SITE.nit}</>}
            {SITE.city && <><br />{SITE.city}</>}
          </p>
        </div>
        <div>
          <h4>Productos</h4>
          <Link to="/secretario">Secretario</Link>
          <Link to="/secretario/funcionalidades">Funcionalidades de Secretario</Link>
          <Link to="/secretario/aprende">Centro de ayuda</Link>
        </div>
        <div>
          <h4>Empresa</h4>
          <Link to="/#servicios">Servicios</Link>
          <Link to="/#nosotros">Nosotros</Link>
          <Link to="/#contacto">Contacto</Link>
        </div>
        <div>
          <h4>Legal</h4>
          <Link to="/politica-de-privacidad">Política de privacidad</Link>
          <Link to="/terminos">Términos y condiciones</Link>
        </div>
        <div>
          <h4>Contacto</h4>
          <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
          <a href={`https://wa.me/${SITE.whatsapp}`} target="_blank" rel="noopener noreferrer">
            WhatsApp {SITE.whatsappDisplay}
          </a>
          {SITE.socials.map((s) => (
            <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer">
              {s.name}
            </a>
          ))}
        </div>
      </div>
      <div className="site-footer__bottom">
        © {new Date().getFullYear()} {SITE.legalName} Todos los derechos reservados.
      </div>
    </div>
  </footer>
)

const Layout = ({ children }) => {
  useScrollOnNavigate()
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  )
}

export default Layout
